import "./seo_snippet_preview/facebook_platform.js";
import "./seo_snippet_preview/google_platform.js";

// VITE_MIGRATION: Preserve sub-properties (Platform, GooglePlatform,
// FacebookPlatform) attached by the child imports above, which run BEFORE
// the class declaration + window assignment below under ES modules.
const __previousSEOSnippetPreview = window.SEOSnippetPreview;

class SEOSnippetPreview {
  constructor(resource, options = {}) {
    this.el = jQuery('<div class="seo-snippet-preview">');
    this.socialActions = jQuery('<div class="social-actions">');
    this.data = { platform: "google", url: resource.publicUrl };
    this.options = {
      showSocialActions: true,
    };

    jQuery.extend(this.options, options);
    this.setupEvents();
    this.selectors = {};
    this.platforms = {
      google: new SEOSnippetPreview.GooglePlatform(options),
      facebook: new SEOSnippetPreview.FacebookPlatform(options),
    };
  }

  setData(data) {
    jQuery.extend(this.data, data);

    if (data.platform) {
      this.el.empty();
      this.currentPlatform = this.platforms[data.platform];
    }

    this.renderText();
    this.renderThumbnail();

    if (data.platform) {
      this.fetchAndRenderSocialActions();
    } else {
      this.renderSocialActions();
    }
  }

  setupEvents() {
    this.el.on("click", ".copy-share-link", (e) => {
      e.preventDefault();
      this.copyShareLink();
    });

    this.el.on("click", ".create-share-link", (e) => {
      e.preventDefault();
      if (!this.isSocialCreateDisabled) {
        this.createShareLink();
      }
      this.isSocialCreateDisabled = true;
    });
  }

  renderText() {
    var anchor = jQuery("<a>", { href: this.data.url });
    var url = this.currentPlatform.urlType == "base" ? anchor.prop("host") : anchor.prop("href");
    var description = this.limitDescription(this.data.description);
    this.el.append(this.currentPlatform.render(this.data.title || "", description, url || "").el);
  }

  renderThumbnail() {
    if (this.data.thumbnail) {
      this.el.find(".preview-image").css("background-image", "url(" + this.data.thumbnail + ")");
      this.el.find(".preview-image").css("background-size", "100%");
    } else {
      this.el.find(".preview-image").css("background-image", "");
      this.el.find(".preview-image").css("background-size", "");
    }
  }

  fetchAndRenderSocialActions() {
    if (!this.currentPlatform.isSocialNetwork || !this.options.showSocialActions) {
      return;
    }

    // If by the time we fetch the share link we're still looking at the same platform, render the social actions
    var requestPlatform = this.currentPlatform;
    this.currentPlatform.getShareLink().then(() => {
      if (requestPlatform == this.currentPlatform) {
        this.renderSocialActions();
      }
    });
  }

  renderSocialActions() {
    if (!this.currentPlatform.isSocialNetwork || !this.options.showSocialActions) {
      return;
    }

    if (this.currentPlatform.shareLink) {
      this.socialActions.html(this.buildCopyLink());
    } else {
      this.socialActions.html(this.buildCreateLink());
    }

    this.el.append(this.socialActions);
  }

  buildCopyLink() {
    return `<button class="social-actions-button copy-share-link" data-behavior="copy-button">Copy Link</button>
      <p class="share-link">Share Link: ${this.currentPlatform.shareLink}</p>`;
  }

  buildCreateLink() {
    return `<button class="social-actions-button create-share-link">Create Share</button>`;
  }

  hide() {
    this.el.empty();
  }

  createShareLink() {
    this.el.find(".create-share-link").addClass("active").html("Loading");
    this.currentPlatform.createShareLink().then(() => {
      this.el.find(".social-actions").empty().append(this.buildCopyLink());
      this.isSocialCreateDisabled = false;
    });
  }

  copyShareLink() {
    const el = document.createElement("textarea");
    el.value = this.currentPlatform.shareLink;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  limitDescription(string) {
    string = string || "";
    var prosessionText = "";
    var maxLength = this.currentPlatform.targets.description || false;
    if (maxLength) {
      if (string.length > maxLength) {
        prosessionText = "...";
      }
      return string.substring(0, maxLength) + prosessionText;
    } else {
      return string;
    }
  }
}

window.SEOSnippetPreview = SEOSnippetPreview;
if (__previousSEOSnippetPreview) {
  Object.assign(window.SEOSnippetPreview, __previousSEOSnippetPreview);
}
